module.exports = {"typedLength":3,"maxResults":5,"canarias":true,"islandToExclude":"fuerteventura,lagomera,elhierro,lanzarote,lapalma","apiUrl":"https://dev-repsol.ed-integrations.com/v1"}


//////////////////
// WEBPACK FOOTER
// ./demo/configuration.json
// module id = HiyV
// module chunks = 1